const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const CargoEstimationCommand: any = {
    PostEstimations: `${Backofficebff}/v1/postcheckout/add-shipment-creation-forecast`,
    PostCargoBacklogDay: `${Backofficebff}/v1/postcheckout/update-estimated-shipped-hours`,
    GetCargoEstimationList: `${Backofficebff}/v1/postcheckout/get-estimated-shipped-info`,
};
